const PHRASES = [
  { text: "Stay Forward.", color: "#1D4ED8" },
  { text: "Run Your Business.", color: "#60A5FA" },
  { text: "Nova Handles the Rest.", color: "#1D4ED8" },
  { text: "Less Busywork.", color: "#93C5FD" },
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {PHRASES.map((p, i) => (
      <span key={i} className="flex items-center">
        <span
          style={{ color: p.color }}
          className="whitespace-nowrap text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter px-8"
        >
          {p.text}
        </span>
        <svg width="22" height="22" viewBox="0 0 24 24" className="shrink-0" aria-hidden="true">
          <path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4z" fill="#60A5FA" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-slate-100 bg-white py-10"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
